// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class MintingClaimsRootItem {
    /**
    * Phase name
    */
    'phase': string;
    /**
    * 0x-prefixed hex merkle root
    */
    'merkle_root': string;
    /**
    * Number of unique addresses in this phase
    */
    'addresses_count': number;
    /**
    * Sum of mint spots for this phase
    */
    'total_spots': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "phase",
            "baseName": "phase",
            "type": "string",
            "format": ""
        },
        {
            "name": "merkle_root",
            "baseName": "merkle_root",
            "type": "string",
            "format": ""
        },
        {
            "name": "addresses_count",
            "baseName": "addresses_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_spots",
            "baseName": "total_spots",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return MintingClaimsRootItem.attributeTypeMap;
    }

    public constructor() {
    }
}

